import React from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";

const ActivityList = ({ activity = [] }) => {
  if (!activity.length) return null;

  return (
    <Box sx={{position: "relative" }}>
      {activity.map((a, index) => {
        const assignBy = a?.attributes?.assignBy;
        const assignTo = a?.attributes?.assignTo;
        const status = a?.attributes?.status;
        let text = "Ticket updated";

        if (assignBy && assignTo) {
          text = `${assignBy} assigned ticket to ${assignTo}`;
        } else if (status) {
          text = `Status changed to ${status}`;
        } else if (a?.type === "created") {
          text = "Ticket created";
        }

        return (
          <Box
            key={a.id || index}
            sx={{
              display: "flex",
              gap: 2,
              position: "relative",
              pb: 0,
              pt: 1,
              borderRadius: 2,
              transition: "0.2s",
              "&:hover": {
                backgroundColor: "#f9f9f9",
              },
            }}
          >
            <Box
              sx={{
                width: 20,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Dot */}
              <Box
                sx={{
                  width: 12,
                  height: 12,
                  borderRadius: "50%",
                  backgroundColor: "#6cc04a",
                  zIndex: 1,
                }}
              />
              {index !== activity.length - 1 && (
                <Box
                  sx={{
                    width: 2,
                    height:30,
                    backgroundColor: "#d6d6d6",
                    mt: 0.5,
                  }}
                />
              )}
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {text}
              </Typography>

              <Typography variant="caption" color="text.secondary">
                {moment(a.date || a.created).fromNow()}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default ActivityList;